import { Link } from "react-router-dom";
import '../../styles/ServiceStyles/Process.css';

const steps = [
    {
        title: "Request a quote",
        text: "Tell us about your business and the licence you need. It takes a few minutes and no account is needed.",
    },
    {
        title: "Consultation",
        text: "A consultant reviews your request and contacts you within 1–2 business days to confirm scope and pricing.",
    },
    {
        title: "Document preparation",
        text: "We help you prepare and check the documents SAHPRA requires, from director's ID and CV to company documents.",
    },
    {
        title: "Submission & approval",
        text: "We guide your application through submission and SAHPRA's review. The process typically takes 6 to 8 weeks.",
    },
];

// Shared by the homepage and the Services page
const Process = () => {
    return(
        <section className="km-section processContainer" id="how-it-works">
            <div className="km-container">
                <div className="km-sectionHead km-sectionHead--center" data-reveal>
                    <p className="km-eyebrow">How it works</p>
                    <h2 className="km-title">From first enquiry to approved licence</h2>
                    <p className="km-lead">Four clear steps, with a consultant guiding you throughout.</p>
                </div>
                {/* data-reveal="mark" doesn't fade the list; it only draws the connecting line */}
                <ol className="process-steps" data-reveal="mark">
                    {steps.map((step, index) => (
                        <li
                            className="process-step"
                            key={step.title}
                            data-reveal
                            style={{ "--reveal-order": index } as React.CSSProperties}
                        >
                            <span className="process-number" aria-hidden="true">{index + 1}</span>
                            <h3>{step.title}</h3>
                            <p>{step.text}</p>
                        </li>
                    ))}
                </ol>
                <div className="process-cta">
                    <Link className="km-btn km-btn--primary" to="/quote">Start with a quote</Link>
                </div>
            </div>
        </section>
    );
};

export default Process;
